module.exports = __webpack_public_path__ + "img/BTC.bef3e5a8.png";